var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showInstallments)?_c('span',{staticClass:"wrapper-installments-promotion"},_vm._l((_vm.installments),function(month){return _c('span',{key:month,staticClass:"discount-value"},[_c('span',[_vm._v(_vm._s(_vm.$t(`general.promo_type.msi`, {
          month,
        }))+"\n    ")])])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }